import {
    CognitoUserPool,
} from 'amazon-cognito-identity-js'

import {
    userPoolId,
    clientId,
    apiURL
} from '../config';


const poolData = {
    UserPoolId: userPoolId,
    ClientId: clientId
};

var tempToken = "eyJraWQiOiJYUjZWMTdsMXFWOXdGeFBiKzhJOG1SQ1g1Uk11M3g5cThibEhQWnkzYks4PSIsImFsZyI6IlJTMjU2In0.eyJzdWIiOiIwOGYxYTM2MC03MDcxLTcwYTgtNjM1MC1mYzQwNDk1ODQxNTQiLCJjdXN0b206cm9sZXMiOiJTdXJ2ZXlWaWV3ZXIsIEFkbWluaXN0cmF0b3JzLCBTeXN0ZW1BZG1pbmlzdHJhdG9ycywgU3VydmV5TWFuYWdlciwgVGVjaG5pY2lhbnMiLCJjb2duaXRvOmdyb3VwcyI6WyJTdXJ2ZXlWaWV3ZXIiLCJTdXJ2ZXlNYW5hZ2VyIiwiQWRtaW5pc3RyYXRvcnMiLCJUZWNobmljaWFucyIsIlN5c3RlbUFkbWluaXN0cmF0b3JzIl0sInByb2ZpbGUiOiJJVCBOZXh1cyIsImlzcyI6Imh0dHBzOlwvXC9jb2duaXRvLWlkcC51cy13ZXN0LTIuYW1hem9uYXdzLmNvbVwvdXMtd2VzdC0yX2s2YUhFQjVFcyIsImNvZ25pdG86dXNlcm5hbWUiOiJiYmVzaWVyLWRldiIsImdpdmVuX25hbWUiOiJCcmlhbiIsImF1ZCI6IjVjcXY2bDc2ZDA1N21zNTlkYnZsdHFwM3A2IiwiZXZlbnRfaWQiOiIyY2RmMDY4Yi02N2E5LTQwY2UtYjVjYi1lM2M5YmQxY2I1NTkiLCJ0b2tlbl91c2UiOiJpZCIsImF1dGhfdGltZSI6MTc0OTA0MTM1NywiY3VzdG9tOmFyZWFzIjoiW1wiQ0EtQ2FsZ2FyeVwiLFwiQ0EtRWRtb250b25cIixcIkNBLUZvcnRTdEpvaG5cIixcIkNBLUxsb3lkbWluc3RlclwiLFwiQ0EtTW9udHJlYWxcIixcIkNBLVNhc2thdG9vblwiLFwiQ0EtVG9yb250b1wiXSIsInBob25lX251bWJlciI6IisxOTQwNTkxOTY5OSIsImV4cCI6MTc0OTA0NDk1NywiaWF0IjoxNzQ5MDQxMzU3LCJmYW1pbHlfbmFtZSI6IkJlc2llciIsImVtYWlsIjoiYmpiZXNpZXJAaXRuZXh1cy5jb20ifQ.RVrIMbFL37-c6ZBfuptv2Hn9nMHoMWuRD5uZpUhbGtt5sbmPzDDjR_TYbiaHUu7JoycoafHZH9iVzl5hk75ERevfC9NYXUDC5ZNCADixRmNZAy3TrsyXSNntyj2pdO90m3pGmv8CIXJFdp5O6KEkoatSLXZxCaIVJKP6Eam-O9hLwKWE1ueSP1EnJvoVDrL_zkpO44qqOgR5VOBjZuv4R9brDMi7b8eSuH8obA-PgpHOKgvxYoJHbwFXNlk_S5vQ5z8WlJjNOXjYVu3AAxP8SZKCHVZi3rCaubn9_RWln8cdLqi4jtnnBxcQpQt5QSmW6z7t5sRXd1oesSkQTqrz6g";

const userPool = new CognitoUserPool(poolData);

const correlatorURL = apiURL;

function getToken() {
    return new Promise((resolve, reject) => {
        var cognitoUser = userPool.getCurrentUser();
        if (cognitoUser !== null) {
            cognitoUser.getSession((err, session) => {
                if (err) {
                    reject(err)
                    return;
                }
                if (!session.isValid()) {
                    reject("Session isn't valid")
                    return;
                }
                resolve(session.idToken.jwtToken);
            })
        }
        else {
            //console.log(tempToken)
            resolve(tempToken);
        }
    })
}


async function _fetch(url, options = {}) {   
    const token = await getToken();
    const {
        headers = {}
    } = options;
    return fetch(url, {
        ...options,
        headers: {
            ...headers,
            "Authorization": token
        }
    })
}

export async function getSurveysByArea(area) {
    try {
        const response = await _fetch(correlatorURL + '/adcGetAreaSurveyList?area=' + area);
        return await response.json();
    } catch (error) {
        return [];
    }
}

export async function getSurveyByID(jobNum) {
    try {
        const response = await _fetch(correlatorURL + '/adcGetSurvey?jobNumVendor=' + jobNum);
        return await response.json();
    } catch (error) {
        return null;
    }
}

export async function getDomainList(listType) {
    try {
        const response = await _fetch(correlatorURL + '/adcGetDomainValues?domain=' + listType);
        return await response.json();
    } catch (error) {
        return null;
    }
}

export async function getSurveyTemplates() {
    try {
        const response = await _fetch(correlatorURL + '/adcGetSurveyTemplates?activeOnly=true');
        return await response.json();
    } catch (error) {
        return null;
    }
}

export async function saveSurvey(survey) {
    try {
        const response = await _fetch(correlatorURL + '/adcSaveSurvey', {
            method: 'POST',
            mode: 'cors',
            body: JSON.stringify(survey)
        });
        return await response.json();
    } catch (error) {
        return null;
    }
}

export async function saveAssetRecord(rec) {
    try {
        const response = await _fetch(correlatorURL + '/adcSaveAssetRecord', {
            method: 'POST',
            mode: 'cors',
            body: JSON.stringify(rec)
        });
        return await response.json();
    } catch (error) {
        return null;
    }
}

export async function loadSurveyFromAssetView(prevJobNum, newJobNum) {
    var params = encodeURI('adcLoadSurveyFromAssetView?prevJobNum=' + prevJobNum + '&newJobNum=' + newJobNum);
    try {
        const response = await _fetch(correlatorURL + params, {
            method: 'POST',
            mode: 'cors'
        });
        return await response.json();
    } catch (error) {
        return null;
    }
}